import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccountSummary } from '@/renderer/services/accountingService';

export function useAccountSummary(companyId: number | null, search: string) {
  return useQuery({
    queryKey: queryKeys.accounting.accountSummary(companyId ?? 0, search),
    queryFn: async () => {
      const result = await fetchAccountSummary(companyId!, search);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch account summary');
      }
      return result.data;
    },
    enabled: !!companyId,
  });
}
